import {createFetcher} from "../../../../tools/fetcher/fetcher";

export const fetchUser = () => {
    return createFetcher({
        headers: {
            "x-tenant-id": "00000000-0000-0000-0000-000000000000",
        },
    }).getRaw("/api/user");
};
